import { useParams } from "react-router-dom";
import { SpinAnimation } from "@twioku/common_components";
import { useActivityReply } from "../features/activityReply/hooks/useActivityReply";
import { ImageList } from "@twioku/common_components";
import { toFormatString } from "../libs/helper";
import { AddCommentForm } from "../features/activityReply/components/AddCommentForm";
import { CommentList } from "../features/activityReply/components/CommentsList";
import { AnswererProfileImage } from "../components/AnswererProfileImage";

export const ActivityReplyDetailPage = () => {
    const params = useParams();
    const id = params.id as string;

    const {
        activityReply,
        newCommentText,
        newCommentImages,
        setNewCommentText,
        addComment,
        setCommentImages,
        isLoading: isActivityReplyLoading,
        isLoadingAddComment,
    } = useActivityReply(id);

    const handleClickQuoteReply = (text: string) => {
        setNewCommentText(text);
    };

    const handleClickSendCommentButton = (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault();
        addComment();
    };

    if (isActivityReplyLoading || !activityReply) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );
    }

    return (
        <main className="mx-auto h-full w-full max-w-5xl">
            <div className="flex h-full w-full max-w-5xl">
                <div className="mx-4 flex-1 pb-36">
                    <article className="mb-4 mt-2">
                        <section>
                            <header>
                                <div className="mt-3">
                                    <div className="flex items-center">
                                        <AnswererProfileImage
                                            src={
                                                activityReply.answererProfleImagePath
                                            }
                                            imageSize="medium"
                                            answererId={
                                                activityReply.answererId
                                            }
                                        />
                                        <div className="ml-2 text-sm font-medium">
                                            {activityReply.answererName}
                                        </div>
                                    </div>
                                </div>
                                <h2 className="mt-6 flex justify-between border-l-4 border-primary px-3 text-sm">
                                    <p>{activityReply.activityTitle}</p>
                                    <p className="text-gray-600">
                                        {toFormatString(
                                            new Date(activityReply.respondDate),
                                            true,
                                            "/"
                                        )}
                                    </p>
                                </h2>
                            </header>
                        </section>
                    </article>
                    <div>
                        <p>{activityReply.respondContent}</p>
                        <ImageList srcList={activityReply.imagePaths ?? []} />
                    </div>
                    <hr className="my-3" />
                    <CommentList
                        comments={activityReply.comments}
                        answererId={activityReply.answererId}
                        handleClickQuoteReply={handleClickQuoteReply}
                    />
                </div>
                <div className="fixed bottom-0 left-0 w-full bg-white">
                    <div className="mx-auto max-w-5xl">
                        <AddCommentForm
                            commentText={newCommentText}
                            imageFiles={newCommentImages}
                            handleChangeCommentText={(e) =>
                                setNewCommentText(e.target.value)
                            }
                            handleClickSendCommentButton={
                                handleClickSendCommentButton
                            }
                            handleChangeAddImageButton={setCommentImages}
                            placeholder="コメントを入力"
                            disabled={isLoadingAddComment}
                            isLoading={isLoadingAddComment}
                        />
                    </div>
                </div>
            </div>
        </main>
    );
};
